import React from "react";
import BreadCrumb from "Components/Common/BreadCrumb";
import { Row, Col, Container } from "reactstrap";
import { GoogleApiWrapper } from "google-maps-react";

import Filters from "../Filters";
import TotalSupport from "../Widgets/TotalSupport";
import TotalContracts from "../Widgets/TotalContracts";
import TotalMDAs from "../Widgets/TotalMDAs";
import TotalPartners from "../Widgets/TotalPartners";
import ContractsPerPaymentCategory from "./ContractsPerPaymentCategory";
import SalaryAlignedDistribution from "./SalaryAlignedDistribution";
import RegionCategoryDistribution from "./RegionCategoryDistribution";

const LoadingContainer = () => <div>Loading...</div>;

const PaymentCategoriesReport = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Payment Categories Report"
            pageTitles={[
              { title: "Dashboard", link: "/dashboard" },
              { title: "Reports" },
            ]}
          />

          <Row>
            <Col lg={12}>
              <Filters />
            </Col>
          </Row>

          <Row>
            <Col lg={3} md={4}>
              <TotalSupport />
            </Col>
            <Col lg={3} md={4}>
              <TotalContracts />
            </Col>
            <Col lg={3} md={4}>
              <TotalMDAs />
            </Col>
            <Col lg={3} md={4}>
              <TotalPartners />
            </Col>
          </Row>

          <Row>
            <Col lg={6}>
              <ContractsPerPaymentCategory />
            </Col>
            <Col lg={6}>
              <SalaryAlignedDistribution />
            </Col>
          </Row>

          <Row>
            <Col lg={12}>
              <RegionCategoryDistribution />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyBZQBNrzq5vDg8Yc73rx3wrnxPD9SA5zTs",
  LoadingContainer: LoadingContainer,
  v: "3",
})(PaymentCategoriesReport);
